import { httpRequest } from '@/request/utils/httprequest.js'
import baseUrl from '@/request/base.js'
import { baseconfig, rsaBasicModuleConfig } from '@/config.js'
import { rsa } from '@/tools/encrypt.js'
import { publicFun } from '@/tools/time.js'
import store from '@/store'
import qs from 'qs'
import request from '@/request/utils/newrequest.js'
// // 公告管理
// export const indexModule = {
//     // 获取公告列表
//     async getindex(){
//         const adminToken = store.getters.adminID
//         var paras = {
//             timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
//             _sign: rsa.signString(baseconfig.v + adminToken +  "~A6S5D4d",rsaBasicModuleConfig.clientPrivateKey),
//         }
//         return await httpRequest(baseUrl.basic  + 'indexinfo?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign), 'get',null, null)
//     },
// }

export const indexModule = {
    // 获取公告列表
    async getindex() {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + "~A6S5D4d", rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'v2/indexinfo?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign), 'get', null, null)
    },

    // 获取公告列表
    async businesslogin(data) {
        return await request({
            url: baseUrl.basic + "businesslogin",
            method: 'post',
            data: qs.stringify(data)
        })
        // return httpRequest(baseUrl.basic + 'businesslogin', 'post', qs.st);
    },
}